// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d15a60bc","455":"2ba8edd8"}[chunkId] + ".chunk.js";
};